export default "__VITE_ASSET__CT3K10RZ__";